var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"owc-stage-cta-buttons",class:{
    'owc-stage-cta-buttons--dark': _vm.isDarkMode,
  }},_vm._l((_vm.ctas),function(cta){return _c('a',{key:cta.label,staticClass:"owc-stage-cta-buttons__button wb-button wb-button--medium",class:[
      {
        'wb-button--theme-dark': _vm.isDarkMode,
        'wb-button--large': !_vm.isMobile,
      },
      _vm.getCtaButtonClasses(cta) ],attrs:{"target":cta.target,"href":cta.url}},[_vm._v(_vm._s(cta.label))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }